import { useEffect, useMemo } from 'react';

export interface AbortCycle {
    next: () => AbortSignal;
    abortLatest: () => void;
}

// Each call aborts the previous request; the cycle's own abortLatest aborts the latest one.
export function createAbortCycle(): AbortCycle {
    let controller: AbortController | null = null;
    return {
        next: () => {
            controller?.abort();
            controller = new AbortController();
            return controller.signal;
        },
        abortLatest: () => controller?.abort()
    };
}

// Each call aborts the previous request; unmounting aborts the latest one.
export function useUnmountAbortSignal(): () => AbortSignal {
    const cycle = useMemo(createAbortCycle, []);
    useEffect(() => cycle.abortLatest, [cycle]);
    return cycle.next;
}
